// extracted by mini-css-extract-plugin
export default {"Courses":"Courses_Courses__Q92Jh","headerContainer":"Courses_headerContainer__cST5x","courseCard":"Courses_courseCard__qDwSl","courseImage":"Courses_courseImage__dCyC+"};